import React, { createContext, useContext, ReactNode } from 'react';
import { Lang, t } from '../i18n';

interface LanguageContextType {
  lang: Lang;
  toggleLang: () => void;
  t: (key: string) => string;
  isRTL: boolean;
  fontFamily: string;
}

const LanguageContext = createContext<LanguageContextType>({
  lang: 'he',
  toggleLang: () => {},
  t: (key: string) => key,
  isRTL: true,
  fontFamily: 'Heebo, sans-serif',
});

export function LanguageProvider({ children }: { children: ReactNode }) {
  // The system is Hebrew-only. The i18n infrastructure (including ar.ts and the
  // *Ar data fields) is kept intact so multi-language support can be re-enabled
  // in the future, but the language is fixed to Hebrew and cannot be switched.
  const lang: Lang = 'he';
  const toggleLang = () => { /* disabled — Hebrew only */ };

  const translate = (key: string) => t(key, lang);
  const fontFamily = 'Heebo, sans-serif';

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t: translate, isRTL: true, fontFamily }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
